const moments = [
  {
    text: "You open the right tab, then freeze.",
    rotate: "-rotate-1",
    offset: "lg:translate-x-2",
  },
  {
    text: "You switch tabs without noticing.",
    rotate: "rotate-1",
    offset: "lg:translate-x-12",
  },
  {
    text: "You remember something urgent and lose the thread.",
    rotate: "-rotate-[0.5deg]",
    offset: "lg:-translate-x-2",
  },
  {
    text: "You hyperfocus until your body disappears.",
    rotate: "rotate-[0.5deg]",
    offset: "lg:translate-x-8",
  },
  {
    text: "You come back from a break and have no idea what you were doing.",
    rotate: "-rotate-1",
    offset: "lg:-translate-x-4",
  },
];

export default function Pain() {
  return (
    <section
      data-testid="pain-section"
      className="relative px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-5xl mx-auto">
        <div className="fade-up">
          <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#475569]">
            The unspoken problem
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-[#0F172A]">
            Most productivity tools assume you can already start.
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed max-w-2xl">
            But ADHD work often breaks before the task even begins.
          </p>
        </div>

        <div className="mt-16 lg:mt-20 relative">
          {/* drift dashed line */}
          <div
            aria-hidden
            className="hidden lg:block absolute inset-x-0 top-1/2 mr-dashed"
          />
          <div className="grid gap-5 lg:gap-6 lg:grid-cols-5">
            {moments.map((m, i) => (
              <div
                key={i}
                data-testid={`pain-card-${i}`}
                className={`fade-up bg-white border border-[#E2E8F0] rounded-2xl p-5 shadow-[0_8px_30px_rgba(42,48,43,0.04)] transform ${m.rotate} ${m.offset} relative`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <span className="font-mono text-[11px] text-[#F59E0B]">
                  0{i + 1}
                </span>
                <p className="font-display text-[17px] leading-snug text-[#0F172A] mt-1.5">
                  {m.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 fade-up">
          <p className="font-display text-2xl sm:text-3xl text-[#0F172A] max-w-2xl leading-snug">
            Mindrail is built for those exact moments.
          </p>
          <div className="mt-5 flex items-baseline gap-3 text-[#475569]">
            <span className="font-mono text-xs text-[#F59E0B]">—</span>
            <p className="text-base">
              Not to push harder.{" "}
              <span className="text-[#0F172A]">To help you come back.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
